import type { InputHTMLAttributes, ReactNode } from "react";
import { Icon } from "./icons";

// Selection controls — codified from 08-formlar-girisler.html "Seçim kontrolleri".
// Each wraps a real (visually-hidden) native input for keyboard + a11y, painting the
// founder's box / dot / track over it. Label copy is the caller's.

type BaseProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & { children: ReactNode };

export function Checkbox({ children, className, ...input }: BaseProps) {
  return (
    <label className={`k-choice${className ? ` ${className}` : ""}`}>
      <input type="checkbox" {...input} />
      <span className="k-check" aria-hidden="true">
        <Icon name="check" size={13} strokeWidth={3} />
      </span>
      {children}
    </label>
  );
}

export function Radio({ children, className, ...input }: BaseProps) {
  return (
    <label className={`k-choice${className ? ` ${className}` : ""}`}>
      <input type="radio" {...input} />
      <span className="k-radio" aria-hidden="true">
        <span className="k-radio__dot" />
      </span>
      {children}
    </label>
  );
}

export function Switch({ children, className, checked, ...input }: BaseProps) {
  return (
    <label
      className={`k-choice k-choice--switch${checked ? "" : " k-choice--off"}${
        className ? ` ${className}` : ""
      }`}
    >
      <input type="checkbox" role="switch" checked={checked} {...input} />
      <span className="k-switch" aria-hidden="true">
        <span className="k-switch__knob" />
      </span>
      {children}
    </label>
  );
}
